import styled from '@emotion/styled/macro';
import { StyledButtonLink } from '@components/Button/styled';

export const TabStatusContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  flex-direction: column;
  align-items: center;
`;

export const TabStatusText = styled.p`
  color: var(--brand-black);
  span {
    font-weight: bold;
  }
`;

export const TabPayButton = styled(StyledButtonLink)`
  width: 250px;
`;
